import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7799443c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nested-array" }
const _hoisted_2 = { class: "nested-array__label" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "nested-card__badge" }
const _hoisted_5 = {
  key: 0,
  class: "nested-card__type-label"
}
const _hoisted_6 = {
  key: 1,
  class: "nested-card__summary"
}
const _hoisted_7 = {
  key: 2,
  class: "nested-card__thumb"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nested-card__spacer" }, null, -1))
const _hoisted_10 = ["disabled", "onClick"]
const _hoisted_11 = ["disabled", "onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "nested-card__body" }
const _hoisted_14 = {
  key: 0,
  class: "nested-card__image-section"
}
const _hoisted_15 = {
  key: 0,
  class: "nested-card__image-preview"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "nested-card__image-upload" }
const _hoisted_18 = { class: "nested-card__file-label" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nested-card__file-icon" }, "📷", -1))
const _hoisted_20 = {
  key: 0,
  class: "nested-card__optional"
}
const _hoisted_21 = ["onChange"]
const _hoisted_22 = ["disabled", "onClick"]
const _hoisted_23 = {
  key: 0,
  class: "nested-card__spinner"
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "nested-card__fields" }
const _hoisted_26 = {
  key: 0,
  class: "nested-card__field-label"
}
const _hoisted_27 = {
  key: 0,
  class: "nested-card__required"
}
const _hoisted_28 = ["placeholder", "value", "onInput"]
const _hoisted_29 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_30 = { class: "nested-card__chip" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 3,
  class: "nested-card__input nested-card__display"
}
const _hoisted_33 = ["onChange"]
const _hoisted_34 = { value: "" }
const _hoisted_35 = ["value"]
const _hoisted_36 = {
  key: 0,
  class: "nested-card__chip-list"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["value", "onChange"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select...", -1))
const _hoisted_40 = ["value"]
const _hoisted_41 = {
  key: 7,
  class: "nested-card__toggle"
}
const _hoisted_42 = ["checked", "onChange"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nested-card__toggle-track" }, null, -1))
const _hoisted_44 = ["type", "placeholder", "value", "onInput"]
const _hoisted_45 = ["value", "onInput"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nested-array__add-icon" }, "+", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GameSelectWithPicker = _resolveComponent("GameSelectWithPicker")!
  const _component_SelectedOrderChips = _resolveComponent("SelectedOrderChips")!
  const _component_DateInput = _resolveComponent("DateInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.input.label), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model, (row, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: idx,
        class: _normalizeClass(["nested-card", { 'nested-card--collapsed': _ctx.isCollapsible && _ctx.isCollapsed(idx) }])
      }, [
        _createElementVNode("div", {
          class: "nested-card__header",
          onClick: ($event: any) => (_ctx.isCollapsible && _ctx.toggle(idx))
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(idx + 1), 1),
          (row.type)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(row.type), 1))
            : _createCommentVNode("", true),
          (_ctx.isCollapsible && _ctx.getSummary(row))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.getSummary(row)), 1))
            : _createCommentVNode("", true),
          (_ctx.isCollapsible && _ctx.isCollapsed(idx) && _ctx.getImagePreview(row))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: _ctx.getImagePreview(row),
                  alt: ""
                }, null, 8, _hoisted_8)
              ]))
            : _createCommentVNode("", true),
          _hoisted_9,
          (_ctx.input.reOrder)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "nested-card__actions",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "nested-card__btn nested-card__btn--move",
                  disabled: idx === 0,
                  onClick: ($event: any) => (_ctx.move(idx, idx - 1)),
                  title: "Move up"
                }, "↑", 8, _hoisted_10),
                _createElementVNode("button", {
                  type: "button",
                  class: "nested-card__btn nested-card__btn--move",
                  disabled: idx === _ctx.model.length - 1,
                  onClick: ($event: any) => (_ctx.move(idx, idx + 1)),
                  title: "Move down"
                }, "↓", 8, _hoisted_11)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: "nested-card__btn nested-card__btn--remove",
            onClick: _withModifiers(($event: any) => (_ctx.$emit('remove', idx)), ["stop"]),
            title: "Remove"
          }, " ✕ ", 8, _hoisted_12),
          (_ctx.isCollapsible)
            ? (_openBlock(), _createElementBlock("div", {
                key: 4,
                class: _normalizeClass(["nested-card__chevron", { 'nested-card__chevron--open': !_ctx.isCollapsed(idx) }])
              }, " ▾ ", 2))
            : _createCommentVNode("", true)
        ], 8, _hoisted_3),
        _withDirectives(_createElementVNode("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.input.columns || [], (col) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: 'img-' + col.name
            }, [
              (col.type === 'image' && (!col.visibleWhen || col.visibleWhen(row)))
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (_ctx.getPreview(row, col))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("img", {
                            src: _ctx.getPreview(row, col),
                            alt: "Preview"
                          }, null, 8, _hoisted_16)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("label", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("span", null, _toDisplayString(_ctx.getPreview(row, col) ? 'Change image' : 'Upload image'), 1),
                        (!col.required)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, "(optional)"))
                          : _createCommentVNode("", true),
                        _createElementVNode("input", {
                          type: "file",
                          accept: ".png,.jpg,.jpeg",
                          onChange: ($event: any) => (_ctx.onFileChange($event, idx, col)),
                          class: "nested-card__file-input"
                        }, null, 40, _hoisted_21)
                      ]),
                      (col.generateAction && col.generateAction.visibleWhen(row, _ctx.relationships))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "nested-card__generate-btn",
                            disabled: _ctx.generating[idx],
                            onClick: ($event: any) => (_ctx.generateImage(idx, row, col))
                          }, [
                            (_ctx.generating[idx])
                              ? (_openBlock(), _createElementBlock("span", _hoisted_23))
                              : (_openBlock(), _createElementBlock("span", _hoisted_24, "✨")),
                            _createTextVNode(" " + _toDisplayString(_ctx.generating[idx] ? 'Generating...' : col.generateAction.label), 1)
                          ], 8, _hoisted_22))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          _createElementVNode("div", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.input.columns || [], (col) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: col.name
              }, [
                (col.type !== 'image' && col.type !== 'hidden')
                  ? _withDirectives((_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["nested-card__field", { 'nested-card__field--wide': col.type === 'textarea' || col.type === 'select' && col.isPicker }])
                    }, [
                      (col.type !== 'date')
                        ? (_openBlock(), _createElementBlock("label", _hoisted_26, [
                            _createTextVNode(_toDisplayString(col.label || col.name) + " ", 1),
                            (col.required)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_27, "*"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (col.type === 'textarea')
                        ? (_openBlock(), _createElementBlock("textarea", {
                            key: 1,
                            class: "nested-card__input nested-card__textarea",
                            rows: "3",
                            placeholder: col.label || col.name,
                            value: _ctx.getValue(row, col),
                            onInput: ($event: any) => (_ctx.setValue(idx, col, $event.target.value))
                          }, null, 40, _hoisted_28))
                        : (col.type === 'select' && col.isPicker)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createVNode(_component_GameSelectWithPicker, {
                                input: col,
                                options: _ctx.getOptions(col),
                                "model-value": _ctx.getValue(row, col),
                                "hide-select": !!col.hideSelect,
                                "onUpdate:modelValue": ($event: any) => (_ctx.setValue(idx, col, $event)),
                                disabled: false
                              }, null, 8, ["input", "options", "model-value", "hide-select", "onUpdate:modelValue"]),
                              (col.value === 'multiple')
                                ? (_openBlock(), _createBlock(_component_SelectedOrderChips, {
                                    key: 0,
                                    "model-value": _ctx.getValue(row, col),
                                    "onUpdate:modelValue": ($event: any) => (_ctx.setValue(idx, col, $event)),
                                    options: _ctx.getOptions(col),
                                    "label-prop": col.multiSelectLabel || 'name'
                                  }, null, 8, ["model-value", "onUpdate:modelValue", "options", "label-prop"]))
                                : (_ctx.getValue(row, col))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                      _createElementVNode("span", _hoisted_30, [
                                        _createTextVNode(_toDisplayString(_ctx.getOptionLabel(col, _ctx.getValue(row, col))) + " ", 1),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "nested-card__chip-remove",
                                          onClick: ($event: any) => (_ctx.setValue(idx, col, null))
                                        }, "✕", 8, _hoisted_31)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                            ], 64))
                          : (col.type === 'display')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.getValue(row, col)), 1))
                            : (col.type === 'select' && col.value === 'multiple')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                  (_openBlock(), _createElementBlock("select", {
                                    class: "nested-card__input nested-card__select",
                                    key: 'ms-' + (_ctx.getValue(row, col) || []).length,
                                    value: '',
                                    onChange: ($event: any) => (_ctx.onMultiAdd(idx, col, $event))
                                  }, [
                                    _createElementVNode("option", _hoisted_34, _toDisplayString(col.label || col.name) + "...", 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOptions(col).filter((o) => !(_ctx.getValue(row, col) || []).includes(o.id ?? o.value ?? o)), (opt) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: opt.value ?? opt.id ?? opt,
                                        value: opt.value ?? opt.id ?? opt
                                      }, _toDisplayString(opt.label ?? opt.name ?? opt), 9, _hoisted_35))
                                    }), 128))
                                  ], 40, _hoisted_33)),
                                  ((_ctx.getValue(row, col) || []).length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.getValue(row, col) || []), (val) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            key: val,
                                            class: "nested-card__chip"
                                          }, [
                                            _createTextVNode(_toDisplayString(_ctx.getOptionLabel(col, val)) + " ", 1),
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "nested-card__chip-remove",
                                              onClick: ($event: any) => (_ctx.removeMultiValue(idx, col, val))
                                            }, "✕", 8, _hoisted_37)
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : (col.type === 'select')
                                ? (_openBlock(), _createElementBlock("select", {
                                    key: 5,
                                    class: "nested-card__input nested-card__select",
                                    value: _ctx.getValue(row, col),
                                    onChange: ($event: any) => (_ctx.setValue(idx, col, $event.target.value))
                                  }, [
                                    _hoisted_39,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOptions(col), (opt) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: opt.value ?? opt.id ?? opt,
                                        value: opt.value ?? opt.id ?? opt
                                      }, _toDisplayString(opt.label ?? opt.name ?? opt), 9, _hoisted_40))
                                    }), 128))
                                  ], 40, _hoisted_38))
                                : (col.type === 'date')
                                  ? (_openBlock(), _createBlock(_component_DateInput, {
                                      key: 6,
                                      input: col,
                                      "model-value": _ctx.getValue(row, col),
                                      "onUpdate:modelValue": ($event: any) => (_ctx.setValue(idx, col, $event))
                                    }, null, 8, ["input", "model-value", "onUpdate:modelValue"]))
                                  : (col.type === 'checkbox')
                                    ? (_openBlock(), _createElementBlock("label", _hoisted_41, [
                                        _createElementVNode("input", {
                                          type: "checkbox",
                                          checked: !!_ctx.getValue(row, col),
                                          onChange: ($event: any) => (_ctx.setValue(idx, col, $event.target.checked))
                                        }, null, 40, _hoisted_42),
                                        _hoisted_43
                                      ]))
                                    : (_openBlock(), _createElementBlock("input", {
                                        key: 8,
                                        class: "nested-card__input",
                                        type: col.type === 'decimal' ? 'number' : 'text',
                                        placeholder: col.label || col.name,
                                        value: _ctx.getValue(row, col),
                                        onInput: ($event: any) => (_ctx.setValue(idx, col, $event.target.value))
                                      }, null, 40, _hoisted_44))
                    ], 2)), [
                      [_vShow, !col.visibleWhen || col.visibleWhen(row)]
                    ])
                  : _createCommentVNode("", true),
                (col.type === 'hidden')
                  ? (_openBlock(), _createElementBlock("input", {
                      key: 1,
                      type: "hidden",
                      value: _ctx.getValue(row, col),
                      onInput: ($event: any) => (_ctx.setValue(idx, col, $event.target.value))
                    }, null, 40, _hoisted_45))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ], 512), [
          [_vShow, !_ctx.isCollapsible || !_ctx.isCollapsed(idx)]
        ])
      ], 2))
    }), 128)),
    (!_ctx.input.hideAdd)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "nested-array__add-btn",
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('add')))
        }, [
          _hoisted_46,
          _createTextVNode(" Add item ")
        ]))
      : _createCommentVNode("", true)
  ]))
}